
  <ion-app>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-app>


